<template>
  <Slide class="ProductsOfInterestSlide"
    v-bind="{ isCurrentSlide, isStartingSlide, mayContinue }"
    :title="content.title"
    nextAction="nextSlide"
  >
    <MultiOptionSelect
      name="inseegoProductsOfInterest"
      v-bind="{ error, optionIcons }"
      :prompt="content.prompt"
      :options="content.options"
      :value="fieldValues.inseegoProductsOfInterest"
      :disabled="!isCurrentSlide"
      @selectionChange="doUpdateField"
    />
  </Slide>
</template>

<script>
import { multiOptionSelectSlideMixin } from '../util/slideBuilders.js'

import MultiOptionSelect from './elems/MultiOptionSelect.vue'
import Slide from './elems/Slide.vue'

import devicesOutdoor from '../assets/option-icons/devices-outdoor.png'
import devicesHotspots from '../assets/option-icons/devices-hotspots.png'
import devicesGateways from '../assets/option-icons/devices-gateways.png'
import devicesIndoor from '../assets/option-icons/devices-indoor.png'
import devicesIot from '../assets/option-icons/devices-iot.png'
import devicesSoftware from '../assets/option-icons/devices-software.png'

const optionIcons = {
  '5G outdoor CPEs': devicesOutdoor,
  '5G mobile hotspots': devicesHotspots,
  '5G industrial gateways': devicesGateways,
  '5G indoor routers': devicesIndoor,
  'LTE/IOT connectivity': devicesIot,
  'Cloud management & networking': devicesSoftware,
}

export default {
  mixins: [multiOptionSelectSlideMixin],
  components: {
    MultiOptionSelect,
    Slide,
  },
  data() {
    return {
      fieldName: 'inseegoProductsOfInterest',
      optionIcons,
    }
  },
}
</script>
